// Core
import React from "react"

// Components
import Article from "../components/article"
import ImageGallery from "../components/imageGallery"
import Interview from "../components/interview"
import Intro from "../components/intro"
import Playlist from "../components/playlist"
import ProgramNotes from "../components/programNotes"
import VideoGallery from "../components/videoGallery"
import WrittenInterview from "../components/writtenInterview"

function getSingleBlock(
  block,
  count,
  episodeInfo,
  blockScrollEvent,
  interviewReverse,
  interviewSequence
) {
  let { __typename } = block,
    { contentful_id } = block

  switch (__typename) {
    case "ContentfulEssay":
      return (
        <Article
          key={contentful_id}
          count={count}
          scrollEvent={blockScrollEvent}
          {...block}
        />
      )
    case "ContentfulImageGallery":
      return (
        <ImageGallery
          key={contentful_id}
          count={count}
          scrollEvent={blockScrollEvent}
          {...block}
        />
      )
    case "ContentfulInterview":
      return (
        <Interview
          key={contentful_id}
          count={count}
          scrollEvent={blockScrollEvent}
          reverse={interviewReverse}
          sequence={interviewSequence}
          {...block}
        />
      )
    case "ContentfulPerformanceIntro":
      return (
        <Intro
          key={contentful_id}
          count={count}
          scrollEvent={blockScrollEvent}
          {...block}
          episodeTitle={episodeInfo.title}
          episodeNumber={episodeInfo.number}
        />
      )
    case "ContentfulPlaylist":
      return (
        <Playlist
          key={contentful_id}
          count={count}
          scrollEvent={blockScrollEvent}
          {...block}
        />
      )
    case "ContentfulProgramNotes":
      return (
        <ProgramNotes
          key={contentful_id}
          count={count}
          scrollEvent={blockScrollEvent}
          {...block}
        />
      )
    case "ContentfulVideoGallery":
      return (
        <VideoGallery
          key={contentful_id}
          count={count}
          scrollEvent={blockScrollEvent}
          {...block}
        />
      )
    case "ContentfulWrittenInterview":
      return (
        <WrittenInterview
          key={contentful_id}
          count={count}
          scrollEvent={blockScrollEvent}
          {...block}
        />
      )
    default:
      return null
  }
}

function blockSwitch(blocks, episodeInfo, blockScrollEvent = null) {
  let blockList = [],
    count = 0,
    interviewReverse = false,
    interviewSequence = false

  if (blocks === null) {
    return blockList
  }

  blocks.forEach(block => {
    blockList.push(
      getSingleBlock(
        block,
        count,
        episodeInfo,
        blockScrollEvent,
        interviewReverse,
        interviewSequence
      )
    )
    count++

    if (block.__typename === "ContentfulInterview" && interviewSequence) {
      count--
    }

    if (block.__typename === "ContentfulInterview") {
      interviewReverse = !interviewReverse
      interviewSequence = true
    } else {
      interviewSequence = false
    }
  })

  return blockList
}

export { blockSwitch }
